// extracted by mini-css-extract-plugin
export default {"journalProject":"JournalProject_journalProject__zLaoN"};